import { render, staticRenderFns } from "./history-quoting-promoter.vue?vue&type=template&id=552b2b3c&scoped=true"
import script from "./history-quoting-promoter.vue?vue&type=script&lang=js"
export * from "./history-quoting-promoter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552b2b3c",
  null
  
)

export default component.exports